import React from 'react';
import { Image } from 'antd';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { formaterMontant } from './formatMontant';

/**
 * Aperçu du produit retrouvé par l'assistant : photo, SKU, variante retenue et
 * stock des autres variantes. Rendu dans la bulle de l'assistant.
 */
const ApercuProduit = ({ produit }) => (
  <div className="mt-3 rounded-lg border border-gray-200 bg-white p-3">
    <div className="mb-2 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-500">
      <ShoppingBagIcon className="h-3.5 w-3.5" aria-hidden="true" />
      Produit trouvé
    </div>
    <div className="flex gap-3">
      {produit.imageUrl && (
        <Image
          width={72}
          height={72}
          preview
          src={produit.imageUrl}
          alt={`Photo de ${produit.name}`}
          className="rounded-md"
          style={{ objectFit: 'cover', borderRadius: 6 }}
        />
      )}
      <div className="min-w-0 flex-1 space-y-1">
        <p className="truncate text-sm font-semibold text-gray-900">{produit.name}</p>
        <p className="text-xs text-gray-500">
          SKU <span className="rounded bg-gray-100 px-1.5 py-0.5 font-mono text-gray-700">{produit.sku || produit.selectedVariant?.sku}</span>
        </p>
        {produit.selectedVariant && (
          <p className="text-sm text-gray-800">
            {produit.selectedVariant.title} · <span className="font-semibold">{formaterMontant(produit.selectedVariant.price)}</span>
          </p>
        )}
        {produit.availableVariants?.length > 0 && (
          <div className="flex flex-wrap gap-1 pt-1">
            {produit.availableVariants.map((variant) => (
              <span key={variant.title} className="rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-[11px] text-gray-600">
                {variant.title} · {variant.availableQuantity}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default ApercuProduit;
